import { defineMessages } from "react-intl";

export const messages = defineMessages({
  headerOrderNumberAddFulfillment: {
    id: "WUjz3P",
    defaultMessage: "Order no. {orderNumber} - Pack & ship",
    description: "page header",
  },
  headerOrderNumberPrepareForPickup: {
    id: "BfQPxx",
    defaultMessage: "Order no. {orderNumber} - Prepare for pickup",
    description: "page header, in-store pickup order",
  },
  itemsToPrepare: {
    id: "wrYMEi",
    defaultMessage: "Items to prepare",
    description: "header, in-store pickup order",
  },
  storePickupTitle: {
    id: "0/3lrO",
    defaultMessage: "In-store pickup",
    description: "card header, in-store pickup order",
  },
  markReadyForPickup: {
    id: "DEw4gP",
    defaultMessage: "Also mark the order ready for pickup",
    description: "checkbox label, in-store pickup order",
  },
  notifyReadyForPickup: {
    id: "ns6XH7",
    defaultMessage: "Email the customer that the order is ready for pickup",
    description: "checkbox label, in-store pickup order",
  },
  submitPreparedForPickup: {
    id: "cAPo4M",
    defaultMessage: "Mark as prepared",
    description: "fulfill in-store pickup order, button",
  },
  submitFulfillment: {
    id: "aRRESk",
    defaultMessage: "Pack & ship",
    description: "fulfill order, button",
  },
  submitPrepareFulfillment: {
    id: "/COhkr",
    defaultMessage: "Prepare shipment",
    description: "prepare order fulfillment, button",
  },
  itemsReadyToShip: {
    id: "N5UuEK",
    defaultMessage: "Items ready to ship",
    description: "header",
  },
  productName: {
    id: "vW3tb6",
    defaultMessage: "Product name",
    description: "name",
  },
  trackingNumberInputLabel: {
    id: "R4IIw1",
    defaultMessage: "Tracking number",
    description: "tracking number of the shipment",
  },
  trackingNumberInputHelperText: {
    id: "Q7eRF7",
    defaultMessage: "Optionally provide a tracking number for this fulfillment",
    description: "tracking number input helper text",
  },
  sku: {
    id: "fw+VAN",
    defaultMessage: "SKU",
    description: "product's sku",
  },
  quantityToFulfill: {
    id: "Kg0Fiu",
    defaultMessage: "Quantity to fulfill",
    description: "quantity of fulfilled products",
  },
  quantity: {
    defaultMessage: "Quantity",
    id: "0mhR+F",
    description: "Header row quantity label",
  },
  stock: {
    defaultMessage: "Stock",
    id: "tZnV8L",
    description: "Header row stock label",
  },
  noStock: {
    id: "z9wQ/U",
    defaultMessage: "No Stock",
    description: "no variant stock in warehouse",
  },
  sentFulfillmentDetails: {
    id: "8Cve4h",
    defaultMessage: "Send fulfillment email to customer",
    description: "checkbox label",
  },
  shipmentInformation: {
    defaultMessage: "Shipment information",
    id: "lF+VJQ",
    description: "Shipment information card header",
  },
  warehouse: {
    defaultMessage: "Warehouse",
    id: "J0lNnk",
    description: "column label",
  },
});
